import React from "react";
import { STATUS_META } from "@/lib/constants";
import { Info } from "lucide-react";

export function PageHeader({ title, subtitle, action }) {
    return (
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
            <div>
                <h1 className="font-heading text-2xl md:text-3xl font-black text-slate-900 tracking-tight">{title}</h1>
                {subtitle && <p className="text-slate-500 mt-1 text-sm">{subtitle}</p>}
            </div>
            {action}
        </div>
    );
}

export function StatusBadge({ status }) {
    const m = STATUS_META[status] || STATUS_META.normal;
    return (
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold border ${m.cls}`} data-testid={`status-${status}`}>
            {m.label}
        </span>
    );
}

const TAG_STYLES = {
    oficial: "bg-petroleum/10 text-petroleum border-petroleum/20",
    usuario: "bg-slate-100 text-slate-600 border-slate-200",
    calculado: "bg-yellow-50 text-yellow-700 border-yellow-200",
    ia: "bg-mineral/10 text-mineralHover border-mineral/20",
};
const TAG_LABELS = {
    oficial: "Dado oficial",
    usuario: "Inserido pelo usuário",
    calculado: "Calculado pelo sistema",
    ia: "Gerado por IA",
};
export function DataTag({ kind }) {
    return (
        <span className={`inline-flex items-center px-2 py-0.5 rounded text-[11px] font-medium border ${TAG_STYLES[kind]}`}>
            {TAG_LABELS[kind]}
        </span>
    );
}

export function Disclaimer({ children }) {
    return (
        <div className="flex items-start gap-2 text-xs text-slate-500 bg-slate-50 border border-slate-200 rounded-md p-3">
            <Info className="w-4 h-4 shrink-0 mt-0.5 text-petroleum" />
            <span>{children || "As informações regulatórias devem ser confirmadas nas fontes oficiais (ANM / gov.br)."}</span>
        </div>
    );
}

export function EmptyState({ icon: Icon, title, desc, action }) {
    return (
        <div className="text-center py-16 border-2 border-dashed border-slate-200 rounded-xl bg-white" data-testid="empty-state">
            {Icon && <Icon className="w-10 h-10 text-slate-300 mx-auto" />}
            <h3 className="mt-4 font-heading font-bold text-slate-700">{title}</h3>
            {desc && <p className="mt-1 text-sm text-slate-400 max-w-sm mx-auto">{desc}</p>}
            {action && <div className="mt-6">{action}</div>}
        </div>
    );
}
